export class RolesConfig {
  currentUserRoles;
}
